export class RolesConfig {
  currentUserRoles;
}
